import { useState } from 'react';

import useQueryParam from '@hooks/use-query-param';

// UI
import BackButton from '@components/back-button';
import Notification from '@components/notification';

// images
import LogoImg from '@assets/logo.png';

// styles
import css from './styles.module.css';

const URL = '/api/auth/verify-email';

function VerifyEmail() {
  const email = useQueryParam('email');
  const [showNotification, setShowNotification] = useState(false);

  const handleEmailSuccessSubmit = () => {
    setShowNotification(true);

    setTimeout(() => {
      setShowNotification(false);
    }, 3000);
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email || '',
        }),
      });

      const data = await response.json();

      console.log(data);

      if (data.status === 'success') {
        handleEmailSuccessSubmit();
      }
    } catch (error) {
      console.error('Error submitting the form:', error);
    }
  };

  return (
    <>
      <main className={css.resetPasswordRoot}>
        <div className={css.content}>
          <BackButton className={css.backButton} iconClassname={css.backIcon} />

          <img src={LogoImg} alt="logo" className={css.logo} />
          <h1 className={css.title}>Verify your email</h1>
          <p className={css.subtitle}>
            We've sent an email to: {email ? email : 'no email provided'} Please
            check your inbox and click the verification link to confirm your
            email address.
          </p>

          <footer className={css.controls}>
            <p className={css.subtitle}>Not seeing the email? </p>
            <button onClick={handleSubmit} className={css.submitButton}>
              Resend
            </button>
          </footer>
        </div>
      </main>

      <Notification
        active={showNotification}
        text="Email has been sent successfully"
      />
    </>
  );
}

export default VerifyEmail;
